// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__-ycbQ","content":"styles_content__3-pxb","row":"styles_row__Ib4jd","footer":"styles_footer__1x8ot","phraseLength":"styles_phraseLength__msJWe"};